export default {
  appointmentContainer: {
    title: 'Planifions la réparation',
    text: 'Nos réparateurs sont disponibles sur les créneaux suivant',
    text2: 'Ces franges correspondent à l’heure d’arrivée attendue du professionnel',
    actions: {
      primary: 'Valider heure',
      secondaryHelpText: 'Aucun de ces créneaux ne vous convient?',
      secondary: 'Je souhaite être rappelé(e)'
    },
    dates: {
      months: {
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Erreur! Il n’a pas été possible de récupérer les jours disponibles pour prendre rendez-vous.',
        postAppointment: 'Erreur! Le rendez-vous sélectionné n’a pas pu être planifié.',
        postContact: 'Erreur! Le contact n’a pas pu être demandé.'
      }
    }
  }
}
